import {SmsLogList} from "./SmsLogList";
import {SmsLogEdit} from "./SmsLogEdit";
import {SmsLogCreate} from "./SmsLogCreate";

export default {
    list: SmsLogList,
    // create: SmsLogCreate,
    // edit: SmsLogEdit
};
